<div class="filter-component">
  <button
    class="expansion-filter"
    mat-menu-item
    #usuariosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="usuarios"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroUserGroupSolid" class="expansion-icon-text" />
      <span class="filter-text"
        >Usuários<ng-container *ngIf="getUsersCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #usuarios="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-usuarios
      [listaUsuarios]="listaUsuarios"
      [(filtroUsuario)]="filtroUsuario"
    ></sub-filtro-usuarios>
  </mat-menu>

  <button
    matButton
    mat-menu-item
    #statusNegociosTrigger="matMenuTrigger"
    [matMenuTriggerFor]="statusNegocio"
    class="expansion-filter"
  >
    <div class="expansion-div">
      <ng-icon name="heroChevronLeftMini" class="icon-expansion" />
      <ng-icon name="heroCalculatorSolid" class="expansion-icon-text" />
      <span class="filter-text"
        >Status do Negócio<ng-container *ngIf="getStatusCount() as cnt">
          ({{ cnt }})
        </ng-container></span
      >
    </div>
  </button>

  <mat-menu #statusNegocio="matMenu" class="container-menu" xPosition="before">
    <sub-filtro-status-negocio
      [listaStatusNegocio]="listaStatusNegocio"
      (atualizaFiltroStatusNegocio)="atualizaFiltroStatusNegocio($event)"
    ></sub-filtro-status-negocio>
  </mat-menu>
</div>
